/* eslint-disable no-unused-vars */

import NewDailyBulletinPreviewGrid from 'components/molecules/NewDailyBulletinPreviewGrid';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function NewDailyBulletinPreview({ toggleState, installationSelected }: any) {
  const toggle = toggleState;
  const installation = installationSelected;
  return (
    <div>
      <NewDailyBulletinPreviewGrid
        toggleState={toggle}
        installationSelected={installation}
      />
    </div>
  );
}

export default NewDailyBulletinPreview;
